<template lang="html">
    <v-container fluid class="">
        <div v-if="show == true" id="cargando" wire:loading class="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gray-700 opacity-75 flex flex-col items-center justify-center ">
            <div class=" loader ease-linear rounded-full border-4 border-t-4 h-12 w-12 mb-4 "></div>
            <h2 class="text-center text-white text-xl font-semibold">Cargando...</h2>
            <p class="w-1/3 text-center text-white">
                Esto puede tardar unos segundos, no cierre esta página.
            </p>
        </div>
        <div class="dashboard-page">

            <v-card>
                <v-card-title class="pa-5 pb-3 primary">

                    <v-toolbar-title style="color: white;">Documentos</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-icon>mdi-file-document</v-icon>

                </v-card-title>
                <v-layout justify-end>
                    <v-btn v-if="this.totalDocs.TotalCapturado == 1"
                           class="ma-2 mr-5 mt-5"
                           v-on:click="MovimientoRecepcion"
                           color="green"
                           dark
                           justify="center">
                        Movimiento Recepción
                        <v-icon dark
                                right>
                            mdi-checkbox-marked-circle
                        </v-icon>
                    </v-btn>
                </v-layout>
                <v-data-table :headers="headers"
                              :items="docs">
                     <template v-slot:[`item.ausa`]="{item}">


                        <v-layout justify-center>
                            <v-tooltip left>
                                <template v-slot:activator="{ on }">
                                    <div v-on="on">
                                        <v-icon v-if="item.gdausadoc == 1"
                                                class="ma-2 justify-center"
                                                align="center"
                                                dark
                                                color="green"
                                                icon
                                                style="width: 50%;">
                                            mdi-check-bold
                                        </v-icon>
                                    </div>
                                </template>
                                <span>SI</span>
                            </v-tooltip>
                        </v-layout>

                        <v-layout justify-center v-if="item.gdausadoc == 0 && item.gdsolicitadoc==0">
                            <v-tooltip left>
                                <template v-slot:activator="{ on }">
                                    <div v-on="on">
                                        <v-icon v-if="item.gdausadoc == 0"
                                                class="ma-2 justify-center"
                                                align="center"
                                                dark
                                                color="red"
                                                icon
                                                style="width: 50%;">
                                            mdi-minus-thick
                                        </v-icon>
                                    </div>
                                </template>
                                <span>NO</span>
                            </v-tooltip>
                            <v-tooltip  left v-if="!ValsoliNuevamente">
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                    color="grey"
                                    fab
                                    x-small
                                    dark
                                     v-on:click="solicitarNuevamente(item.doclave,)"
                                    >
                                    <v-icon>mdi-cached</v-icon>
                                    </v-btn>
                                </template>
                                <span>Solicitar Nuevamente</span>
                            </v-tooltip>
                        </v-layout>
                         <v-layout justify-center  v-if="item.gdausadoc == 0 && item.gdsolicitadoc==1">
                            <v-tooltip left>
                                <template v-slot:activator="{ on }">
                                    <div v-on="on">
                                        <v-icon 
                                                class="ma-2 justify-center"
                                                align="center"
                                                dark
                                                color="orange"
                                                icon
                                                style="width: 50%;">
                                            mdi-folder-refresh
                                        </v-icon>
                                    </div>
                                </template>
                                <span>Se solicito nuevamente</span>
                            </v-tooltip>
                        </v-layout>
                    </template>
                      <template v-slot:[`item.ausa2`]="{item}">


                       

                    </template>
                    <template v-slot:[`item.calif`]="{item}">

                        <!---->
                        <v-layout justify-center>
                            <div :class="validaConclusion==false ? 'disabled-button' : ''">
                                <!-- <v-btn v-if="item.gdvaldig == 'N/A' && (item.gdausadoc == true || item.gdsolicitadoc==true)  && item.docid != 'N/A'" -->
                                <v-btn v-if="item.gdvaldig == 'N/A' && item.gdausadoc == true  && item.docid != 'N/A'"
                                       class="ma-2"
                                       v-on:click=" CargarVistaCal(item.docid, item.dodescrip, item.doclave,828,item.docpaginas,item.gdvaldoctosausa)"
                                       color="primary"
                                       dark
                                       justify="center">
                                    Calificar
                                    <v-icon dark
                                            right>
                                        mdi-checkbox-marked-circle
                                    </v-icon>
                                </v-btn>
                            </div>

                        </v-layout>

                        <v-layout justify-center>
                            <v-tooltip left>
                                <template v-slot:activator="{ on }">
                                    <div v-on="on">
                                        <v-icon v-if="item.gdvaldig == '0'"
                                                class="ma-2 justify-center"
                                                align="center"
                                                dark
                                                color="warning"
                                                icon large
                                                style="width: 50%;">
                                            mdi-account-clock-outline
                                        </v-icon>
                                    </div>
                                </template>
                                <span>Pendiente</span>
                            </v-tooltip>
                        </v-layout>

                        <v-layout justify-center>
                            <v-tooltip left>
                                <template v-slot:activator="{ on }">
                                    <div v-on="on">
                                        <!-- <v-icon v-if="(item.gdvaldig == '1') || ((item.gdausadoc == false  &&  item.gdsolicitadoc==false) && item.docid !== 'N/A')" -->
                                        <v-icon v-if="(item.gdvaldig == '1') || (item.gdausadoc == false   && item.docid !== 'N/A')"
                                                class="ma-2 justify-center"
                                                align="center"
                                                dark
                                                icon large
                                                style="width: 50%;">
                                            mdi-checkbox-marked
                                        </v-icon>
                                    </div>
                                </template>
                                <span>Correcto</span>
                            </v-tooltip>
                        </v-layout>





                    </template>

                    <template v-slot:[`item.calif2`]="{item}">


                        <v-layout justify-center>
                            <div :class="validaConclusion==false ? 'disabled-button' : ''">
                                <!-- <v-btn v-if="item.gdvaldig == 1 && item.gdvallegal == 'N/A' && (item.gdausadoc == true || item.gdsolicitadoc==true) && item.docid != 'N/A'" -->
                                <v-btn v-if="item.gdvaldig == 1 && item.gdvallegal == 'N/A' && item.gdausadoc == true  && item.docid != 'N/A'"
                                       class="ma-2"
                                       v-on:click=" CargarVistaCal(item.docid, item.dodescrip, item.doclave,829,item.docpaginas)"
                                       color="primary"
                                       dark>
                                    Calificar
                                    <v-icon dark
                                            right>
                                        mdi-checkbox-marked-circle
                                    </v-icon>
                                </v-btn>
                            </div>
                        </v-layout>

                        <v-layout justify-center>
                            <v-tooltip left>
                                <template v-slot:activator="{ on }">
                                    <div v-on="on">
                                        <!-- <v-icon v-if="item.gdvallegal == '1' || item.gdvallegalcliente == 1 || ((item.gdausadoc == false  &&  item.gdsolicitadoc==false) && item.docid !== 'N/A')" -->
                                        <v-icon v-if="item.gdvallegal == '1' || item.gdvallegalcliente == 1 || (item.gdausadoc == false  && item.docid !== 'N/A')"
                                                class="ma-2 "
                                                justify="center"
                                                dark
                                                center
                                                icon large
                                                style="width: 50%;">
                                            mdi-checkbox-marked
                                        </v-icon>
                                    </div>
                                </template>
                                <span>Correcto</span>
                            </v-tooltip>
                        </v-layout>

                        <v-layout justify-center>
                            <v-tooltip left>
                                <template v-slot:activator="{ on }">
                                    <div v-on="on">
                                        <v-icon v-if="item.gdvallegal == '0' && item.gdvallegalcliente =='N/A'"
                                                class="ma-2 justify-center"
                                                align="center"
                                                dark
                                                color="warning"
                                                icon large
                                                style="width: 50%;">
                                            mdi-alert-octagon
                                        </v-icon>
                                    </div>
                                </template>
                                <span>Pendiente</span>
                            </v-tooltip>
                        </v-layout>

                        <v-layout justify-center>
                            <v-tooltip left>
                                <template v-slot:activator="{ on }">
                                    <div v-on="on">
                                        <v-icon v-if="item.gdvallegal == '0' && item.gdvallegalcliente =='0'"
                                                class="ma-2 justify-center"
                                                align="center"
                                                dark
                                                color="error"
                                                icon large
                                                style="width: 50%;">
                                            mdi-alert
                                        </v-icon>
                                    </div>
                                </template>
                                <span>Denegado</span>
                            </v-tooltip>
                        </v-layout>

                        <!--<v-layout justify-center>

            </v-layout>-->


                    </template>

                    <template v-slot:[`item.calif3`]="{item}">


                        <v-layout justify-center>
                            <div :class="validaConclusion==false ? 'disabled-button' : ''">
                                <v-btn v-if="((item.gdvallegal == 1 || item.gdvallegalcliente == 1) && (item.gdrecepfisc==1 && item.gdvalfis=='N/A') || (item.gdausadoc == false && item.gdvalfis=='N/A' && item.gdrecepfisc==1))"
                                       class="ma-2"
                                       v-on:click=" CargarVistaCal(item.docid, item.dodescrip, item.doclave, 830,item.docpaginas)"
                                       color="primary"
                                       dark>
                                    Calificar
                                    <v-icon dark
                                            right>
                                        mdi-checkbox-marked-circle
                                    </v-icon>
                                </v-btn>
                                </div>
                        </v-layout>


                        <v-layout justify-center>
                            <v-tooltip left>
                                <template v-slot:activator="{ on }">
                                    <div v-on="on">
                                        <v-icon v-if="item.gdvalfis == '1' || item.gdvalfiscliente == 1"
                                                class="ma-2 "
                                                justify="center"
                                                dark
                                                center
                                                icon large
                                                style="width: 50%;">
                                            mdi-checkbox-marked
                                        </v-icon>
                                    </div>
                                </template>
                                <span>Correcto</span>
                            </v-tooltip>
                        </v-layout>


                        <v-layout justify-center>
                            <v-tooltip left>
                                <template v-slot:activator="{ on }">
                                    <div v-on="on">
                                        <v-icon v-if="item.gdvalfis == '0' && item.gdvalfiscliente == 'N/A'"
                                                class="ma-2 justify-center"
                                                align="center"
                                                dark
                                                color="warning"
                                                icon large
                                                style="width: 50%;">
                                            mdi-alert-octagon
                                        </v-icon>
                                    </div>
                                </template>
                                <span>Pendiente</span>
                            </v-tooltip>
                        </v-layout>


                        <v-layout justify-center>
                            <v-tooltip left>
                                <template v-slot:activator="{ on }">
                                    <div v-on="on">
                                        <v-icon v-if="item.gdvalfis == '0' && item.gdvalfiscliente =='0'"
                                                class="ma-2 justify-center"
                                                align="center"
                                                dark
                                                color="error"
                                                icon large
                                                style="width: 50%;">
                                            mdi-alert
                                        </v-icon>
                                    </div>
                                </template>
                                <span>Denegado</span>
                            </v-tooltip>
                        </v-layout>



                    </template>

                    <template v-slot:[`item.calif4`]="{item}">

                        <!---->
                        <v-layout justify-center>
                            <div :class="validaConclusion==false ? 'disabled-button' : ''">
                                <v-btn v-if="((item.gdvallegal == 1 || item.gdvallegalcliente == 1 || item.gdausadoc == 0) 
                                && (item.gdrecepfisc=='N/A' && item.movRecep == 1 ))"
                                       class="ma-2"
                                       v-on:click=" CargarVistaCal(item.docid, item.dodescrip, item.doclave, 1,item.docpaginas)"
                                       color="primary"
                                       dark>
                                    Calificar
                                    <v-icon dark
                                            right>
                                        mdi-checkbox-marked-circle
                                    </v-icon>
                                </v-btn>
                            </div>
                        </v-layout>


                        <v-layout justify-center>
                            <v-tooltip left>
                                <template v-slot:activator="{ on }">
                                    <div v-on="on">
                                        <v-icon v-if="item.gdrecepfisc == '1'"
                                                class="ma-2 "
                                                justify="center"
                                                dark
                                                center
                                                icon large
                                                style="width: 50%;">
                                            mdi-checkbox-marked
                                        </v-icon>
                                    </div>
                                </template>
                                <span>Correcto</span>
                            </v-tooltip>
                        </v-layout>


                        <v-layout justify-center>
                            <v-tooltip left>
                                <template v-slot:activator="{ on }">
                                    <div v-on="on">
                                        <v-icon v-if="item.gdrecepfisc == '0'"
                                                class="ma-2 justify-center"
                                                align="center"
                                                dark
                                                color="warning"
                                                icon large
                                                style="width: 50%;">
                                            mdi-alert-octagon
                                        </v-icon>
                                    </div>
                                </template>
                                <span>Pendiente</span>
                            </v-tooltip>
                        </v-layout>
                    </template>

                   

                </v-data-table>



                <v-row justify="center">
                    <v-dialog v-model="verarchi"
                              scrollable
                              persistent
                              max-width="70%">
                        <v-card>
                            <v-card-title>
                                <span class="text-h5">{{nombreArchivo}}</span>
                            </v-card-title>
                            <v-card-text>
                                <v-progress-linear :active="loading"
                                                   :indeterminate="loading"
                                                   color="primary"
                                                   class="mb-0"></v-progress-linear>
                                <div id="ver" class="py-3 text-center"></div>
                            </v-card-text>
                            <v-card-actions class="justify-end">
                                <v-btn dark
                                       color="error"
                                       @click="CerrarVisor()">
                                    Close
                                    <v-icon>
                                        mdi-close-outline
                                    </v-icon>
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </v-row>
            </v-card>
        </div>
    </v-container>
</template>
<style>

    .v-data-table-header th {
        white-space: nowrap;
    }

    .calfCol {
        padding-left: 30%;
    }

    .disabled-button{
        pointer-events: none;
    }
</style>

<script>
    import { mapState } from 'vuex';
    import Documentos from '@/services/Documentos/documentos.service.js';
    import utils from '@/utils/managerLocalStorage.js';
    import Seguimiento from '@/services/GestoriaDoc/Seguimientos.service.js'
    import MetodosGenerales from "@/utils/metodosgenerales.vue.js";
    export default {
        components: {

        },
        data() {
            return {
                verarchi: false,
                loading: false,
                docs: [],
                headers: [
                    { text: 'Tipo Archivo', value: 'dodescrip', class: "text title" },
                    { text: 'Gestoría AUSA', align: 'center', value: 'ausa', class: "text title calfCol" },
                    { text: 'Fecha', value: 'docalta', class: "text title" },
                    { text: 'Validación Digital', align: 'center', value: 'calif', class: "text title calfCol" },
                    { text: 'Validación Legal', align: 'center', value: 'calif2', class: "text title calfCol" },
                    { text: 'Validación Recepción', align: 'center', value: 'calif4', class: "text title calfCol" },
                    { text: 'Validación Física', align: 'center', value: 'calif3', class: "text title calfCol" }
                    
                ],
                checkbox:"",
                doid: '',
                reporte: [],
                nombreArchivo: '',
                show: true,
                abierto: false,
                movDoc: false,
                totalDocs: [],
                status: 0,
                validaConclusion: "",
                isDisabled: false,
                ValsoliNuevamente: true,

            };
        },

        methods: {
            ObtenerDocs() {
                var formData = new FormData();
                formData.append("nrreporte", this.reporte.nrreporte);
                formData.append("svindice", this.reporte.svindice);
                Documentos.ObtenerDocumentosAdjuntos(this, formData).then(data => {
                    this.docs = data;
                    this.show = false;
                });
                this.ValidaDocValDigital();
                
            },
            ObtenerTotal() {
                var formData = new FormData();
                formData.append("nrreporte", this.reporte.nrreporte);
                formData.append("svindice", this.reporte.svindice);
                Documentos.TotalCheck(this, formData).then(data => {
                    let totalData = data[0];

                    if (data.length > 0) {
                        for (const [key, value] of Object.entries(totalData)) {
                            if (typeof value == "object") { totalData[key] = "" }
                        }
                        this.totalDocs = totalData;
                    }
                });
                Documentos.RevisarStatus(this, formData).then(data => {
                    let totalData = data[0];
                    for (const [key, value] of Object.entries(totalData)) {
                        if (typeof value == "object") { totalData[key] = "" }
                    }
                    this.status = totalData.RESULT;
                });
            },
            solicitarNuevamente(doclave){
                var formData = new FormData();
                    formData.append("nrreporte", this.reporte.nrreporte);
                    formData.append("svindice", this.reporte.svindice);
                    formData.append("doclave", doclave);
                    Seguimiento.SolicitarNuevamente(this, formData).then(data => {
                        this.ObtenerDocs();
                   });
            },
            ValidaDocValDigital(){
                var formData = new FormData();
                    formData.append("nrreporte", this.reporte.nrreporte);
                    formData.append("svindice", this.reporte.svindice);
                 return   Seguimiento.ValidaDocValDigital(this, formData);
            },
            MovimientoRecepcion() {

                this.$router.push({
                    name: "ReporteAgregarMovimientoGD",
                    params: { opc: 823 , valor: 'S' },
                });
            },
            CerrarVisor() {
                this.verarchi = false;
                document.querySelector("iframe").remove();
            },
            CargarVistaCal(docid, docDescrip, doclave, ceclave, docpaginas,validadoctosausa) {

                if (ceclave == 830) {
                    var formData = new FormData();
                    formData.append("nrreporte", this.reporte.nrreporte);
                    formData.append("svindice", this.reporte.svindice);
                    Documentos.RevisarStatus(this, formData).then(data => {

                        let totalData = data[0];
                        for (const [key, value] of Object.entries(totalData)) {
                            if (typeof value == "object") { totalData[key] = "" }
                        }

                        if (totalData.RESULT == 1 || totalData.RESULT == 2) {
                            sessionStorage.setItem('idDoc', docid)
                            sessionStorage.setItem('idDes', docDescrip)
                            sessionStorage.setItem('doclave', doclave)
                            sessionStorage.setItem('ceclave', ceclave)
                            sessionStorage.setItem('docpaginas', docpaginas)

                            this.$router.push({ name: `docCalif` })
                        }
                        else {
                            this.$swal({
                                position: 'center',
                                icon: 'warning',
                                title: 'Error',
                                text: 'Realiza el movimiento de validación de recepción y verifica que sea con respuesta SI ',
                                showConfirmButton: false,
                                timer: 4500
                            });
                        }

                       
                    });
                }
                else if (ceclave == 828) {
                    if (validadoctosausa) {
                        sessionStorage.setItem('idDoc', docid);
                        sessionStorage.setItem('idDes', docDescrip);
                        sessionStorage.setItem('doclave', doclave);
                        sessionStorage.setItem('ceclave', ceclave);
                        sessionStorage.setItem('docpaginas', docpaginas);
                        this.$router.push({ name: `docCalif` });
                    }
                    else {
                        this.$swal({
                            position: 'center',
                            icon: 'warning',
                            title: 'Error',
                            text: 'Realiza la Confirmación de Documentos para poder realizar la validación digital',
                            showConfirmButton: true,
                            timer: 5000
                        });
                    }
                    

                }
                else {
                    sessionStorage.setItem('idDoc', docid)
                    sessionStorage.setItem('idDes', docDescrip)
                    sessionStorage.setItem('doclave', doclave)
                    sessionStorage.setItem('ceclave', ceclave)
                    sessionStorage.setItem('docpaginas', docpaginas)
                   
                    this.$router.push({ name: `docCalif` })
                }
                
            },
            async obtenerEstadoReporte() {
                this.validaConclusion = await MetodosGenerales.getReporteEstatus(this);
                MetodosGenerales.recurse();
                if (this.validaConclusion == false) {
                    this.goBackTo();
                }
            },
        },

        created: function () {

        },

        computed: {
            ...mapState(["domain", "theme"]),
            ...mapState("Operacion", ["key"]),
            
        },
        async mounted() {
            //this.reporte = JSON.parse(sessionStorage.getItem('reporte'));
            this.reporte = await MetodosGenerales.obtenerSessionReporte('reporte');
            this.ObtenerDocs();
            this.ObtenerTotal();
            this.obtenerEstadoReporte();
          

            
        },
        watch: {
            loading(val) {
                if (!val) return;

                setTimeout(() => (this.loading = false), 3000);
            },
        },

    };
</script>